import { render } from "./printerStatus.vue?vue&type=template&id=657d0960&scoped=true"
import script from "./printerStatus.vue?vue&type=script&lang=js"
export * from "./printerStatus.vue?vue&type=script&lang=js"

import "./printerStatus.vue?vue&type=style&index=0&id=657d0960&scoped=true&lang=css"

import exportComponent from "C:\\Users\\hkun\\Downloads\\print_shop-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-657d0960"]])

export default __exports__